import React, { Component } from "react";

import Box from '@material-ui/core/Box';

import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import NativeSelect from '@material-ui/core/NativeSelect';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Paper';
import PublishIcon from '@material-ui/icons/Publish';

import CurriculumFields from "./CurriculumFields.js";

class Curriculum extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fileSelectd: 0,
			uploading: 0,
			file: '',
			uploadingPortrait: 0
		};
		
		this.handleChange = this.handleChange.bind(this);
		this.handleChangeFields = this.handleChangeFields.bind(this);
		this.handlecheckboxLang = this.handlecheckboxLang.bind(this);
		this.handleChangeFYE = this.handleChangeFYE.bind(this);
		this.handleSector = this.handleSector.bind(this);
		this.downloadCV = this.downloadCV.bind(this);
		this.renderDocuments = this.renderDocuments.bind(this);
		this.renderUploadFile = this.renderUploadFile.bind(this);
		this.renderPortrait = this.renderPortrait.bind(this);
		this.handleUpload = this.handleUpload.bind(this);
		this.handleDocument = this.handleDocument.bind(this);
		this.handlePortrait = this.handlePortrait.bind(this);
		this.isJson = this.isJson.bind(this);
	}

	handleChange(e) {
		e.preventDefault();
		let cv = this.props.cv;
		cv[e.target.name]=e.target.value;
		this.props.handleChangeCurriculum(cv);
	}
	
	handleChangeFields(fieldsName, fieldValue){
		let cv = this.props.cv;
		cv[fieldsName]=JSON.stringify(fieldValue);
		this.props.handleChangeCurriculum(cv);
	}
	
	handlecheckboxLang(e){
		e.preventDefault();
		let cv = this.props.cv
		let langDef=e.target.value.split("$");
		var newLang;
		if(e.target.checked){
			newLang=cv.languages;
			newLang.push({id:Number(langDef[1]),code:langDef[2]});
		}else{
			newLang=cv.languages.filter(lp => lp.id != Number(langDef[1]));
		}
		this.props.handleChangeCurriculum(cv);
	}
	
	handleChangeFYE(e) {
		e.preventDefault();
		let newDate = new Date();
		let cv = this.props.cv;
		cv.firstYearOfExperience=newDate.getFullYear()-e.target.value;
		this.props.handleChangeCurriculum(cv);
	}
	
	handleSector(e){
		let cv = this.props.cv;
		let sectorDef=e.target.value.split("_");
		let bit=Number(sectorDef[1]);
		var newSectors;
		if(e.target.checked){
			cv.sectors = cv.sectors | bit;
		}else{
			cv.sectors = cv.sectors & (~bit);
		}
		this.props.handleChangeCurriculum(cv);
	}
	
	handleDocument(e) {
		e.preventDefault();
		this.setState({fileSelectd: 1});
		this.setState({file: e.target.files[0]});
	}
	
	handlePortrait(e){
		e.preventDefault();
		this.setState({uploadingPortrait: 1});
		this.props.uploadPortrait(this.props.cv.id, e.target.files[0])
			.then(response => { return this.setState({uploadingPortrait: 0});})
			.catch(err => {/*console.log(err);*/});
	}
	
//	handleImage(e) {
//		//console.log('handleImage ['+this.props.newOrder.id+'] ]: '+e.target.value+':'+e.target.files[0]);
//		this.props.actions.updateDocument(this.props.cv.id, e.target.files[0]);
//	}


	renderDocuments(){
		let documents = [];
		var linkKeys = Object.keys(this.props.cv._links);
		if(linkKeys){
			//<a target="_blank" href={this.props.xlfDocument.href+"/content?access_token="+this.props.accessToken} title={this.props.xlfDocument.title}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#27ae60", cursor: "pointer"}}>&#59408;</Icon></a>
			documents = linkKeys.filter(k => k!=='self').map( attachmentK => <li><a target="_blank" href={this.props.cv._links[attachmentK].href+"/content?access_token="+this.props.accessToken}>{attachmentK}</a></li>);
		}
		return <ul>{documents}</ul>;
	}
	
	downloadCV(){
		this.props.downloadCV(this.props.cv.id);
	}
	
	handleSubmit(e) {
		e.preventDefault();
		this.props.saveCurriculum();
	}
	
	handleUpload(e){
		this.setState({uploading: 1});
		this.props.uploadFile(this.props.cv.id, this.state.file)
			.then(response => { return this.setState({uploading: 0});})
			.catch(err => {/*console.log(err);*/});
	}
	
	renderUploadFile(){
		const disabled = this.state.fileSelectd===0;
		if(this.state.uploading>0){
			return <Grid item xs={12}>UPLOADING....</Grid>
		}
		return <Grid container item direction="row" alignItems="stretch" justify="flex-start" xs={12}>
					<Grid item xs={6}>
						<Paper>
							<Button label="Choose TMX" component="span">
								<input type="file" name="docuemnt" style={{ overflow: 'hidden' }} onChange={this.handleDocument}/>
							</Button>
						</Paper>
					</Grid>
					<Grid item  xs={1}>
					</Grid>
					<Grid item  xs={5}>
						<Button disabled={disabled} style={{fontFamily: "'Lato', sans-serif", fontSize: "12px", backgroundColor: "#dfdfdf"}} onClick={this.handleUpload} color="primary">
							<PublishIcon/>
						</Button>
					</Grid>
				</Grid>
	}
	
	renderPortrait(){
		const disabled = this.state.fileSelectd===0;
		if(this.state.uploadingPortrait>0){
			return <Grid item xs={12}>UPLOADING....</Grid>
		}
		
		let portrait;
		if(this.props.portrait!=null){
			//let imgdata="data:image/jpg;base64,"+btoa(this.props.portrait);
			let imgdata="data:image/jpg;base64,"+this.props.portrait;
			//<img src={URL.createObjectURL(responseData)} />
			portrait = <img src={URL.createObjectURL(this.props.portrait)} alt="cvimage" className="cvimage"/>
		}else{
			portrait = <img src={"/img/cv/cv_image_"+this.props.id+".jpg"} onError={(e)=>{e.target.src="/img/cv/default_profile_picture.jpg"}} alt="cvimage" className="cvimage"/>
		}
		return <Grid container item direction="row" xs={3}>
					<Grid item>
						<div className="cvimage">
						{portrait}
						</div>
					</Grid>
					<Grid item>
						<Button label="Upload image" component="span">
							<input type="file" name="portrait" style={{ overflow: 'hidden' }} onChange={this.handlePortrait}/>
						</Button>
					</Grid>
				</Grid>
	}
	
	isJson(item) {
		item = typeof item !== "string" ? JSON.stringify(item) : item;
	
		try {
			item = JSON.parse(item);
		} catch (e) {
			return false;
		}
		return (typeof item === "object" && item !== null);
	}
	
	render() {
		//console.log(this.props.cv);
		let newDate = new Date();
	
		let languagePairs = [];
		if(typeof(this.props.langPairs)!=="undefined" && this.props.cv && this.props.cv.languages){
			this.props.langPairs.forEach((lp) => {
				if(lp.trg!==null){
					languagePairs.push(
						<Grid item xs={2}>
							<FormControlLabel 
									control={
										<Checkbox
											defaultChecked={ this.props.cv.languages.find(lang => {if(lang.id == lp.id){ return true;}})!=null }
											value={"lang$"+lp.id+"$"+lp.code}
											color="primary"
											name={"lang$"+lp.id+"$"+lp.code}
											onChange={this.handlecheckboxLang}
										/>
									}
									label={lp.code}
								/>
						</Grid>
					)
				}
			});
		}
		if(this.props.cv==null) return <div>LOADING...</div>
		
		var education;
		var practices;
		
		if(this.props.cv.education === "" || this.isJson(this.props.cv.education)){
			let educationFields = this.props.cv.education === "" ? [] : JSON.parse(this.props.cv.education);
			education = <CurriculumFields
							fieldsName = "education"
							fields = {educationFields}
							handleChange = {this.handleChangeFields}
						/>
		}else{
			education = <textarea
							onChange={this.handleChange}
							style={{width: "100%"}}
							rows="4"
							id="practices"
							name="practices"
							value={this.props.cv.education}
						/>
		}
		if(this.props.cv.practices === "" || this.isJson(this.props.cv.practices)){
			let practicesFields = this.props.cv.practices === "" ? [] : JSON.parse(this.props.cv.practices);
			practices = <CurriculumFields
							fieldsName = "practices"
							fields = {practicesFields}
							handleChange = {this.handleChangeFields}
						/>
		}else{
			practices = <textarea
							onChange={this.handleChange}
							style={{width: "100%"}}
							rows="4"
							id="practices"
							name="practices"
							value={this.props.cv.practices}
						/>
		}
		
		return (
		<div class="contentM">
		<form>
		<Grid container item direction="column" alignItems="stretch" justify="flex-start" xs={12}>
			<Grid item xs={12}>
				<h2 className="title">CV <Tooltip title="Download curriculum"><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#27ae60", cursor: "pointer" }} onClick={this.downloadCV}>&#59408;</Icon></Tooltip></h2>
			</Grid>
			<Grid item xs={12}>
				Atachments:
			</Grid>
			<Grid item xs={12}>
				{this.renderDocuments()}
			</Grid>
			{this.renderUploadFile()}
			<Grid item className="sectionTitle" xs={12}>
				Personal Information
			</Grid>
			<Grid container item direction="row" alignItems="stretch" justify="flex-start" xs={12}>
				<Grid container item direction="column" alignItems="flex-start" justify="flex-start" xs={9}>
						<Grid container item direction="row" alignItems="stretch" justify="flex-start">
							<Grid item xs={3}>
								<TextField
										id="name"
										name="name"
										label="Name: "
										defaultValue={this.props.cv.name}
										margin="normal"
										onChange={this.handleChange}
									/>
							</Grid>
							<Grid item xs={6}>
								<TextField
										id="surname"
										name="surname"
										label="Surname: "
										defaultValue={this.props.cv.surname}
										margin="normal"
										fullWidth
										onChange={this.handleChange}
									/>
							</Grid>
						</Grid>
						<Grid container item direction="row" alignItems="stretch" justify="flex-start">
							<Grid item xs={3}>
								<TextField
									id="phone"
									name="phone"
									label="Tel: "
									defaultValue={this.props.cv.phone}
									margin="normal"
									fullWidth
									onChange={this.handleChange}
								/>
							</Grid>
							<Grid item xs={6}>
								<TextField
									id="address"
									name="address"
									label="Address: "
									defaultValue={this.props.cv.address}
									margin="normal"
									onChange={this.handleChange}
								/>
							</Grid>
						</Grid>
						<Grid container item direction="row" alignItems="stretch" justify="flex-start">
							<Grid item xs={3}>
								<TextField
									id="birthDate"
									name="birthDate"
									label="Birth date: "
									defaultValue={this.props.cv.birthDate}
									margin="normal"
									onChange={this.handleChange}
								/>
							</Grid>
							<Grid item xs={3}>
								<TextField
									id="nationality"
									name="nationality"
									label="Nationality: "
									defaultValue={this.props.cv.nationality}
									margin="normal"
									onChange={this.handleChange}
								/>
							</Grid>
							<Grid item xs={3}>
								<TextField
									id="nif"
									name="nif"
									label="Nif: "
									defaultValue={this.props.cv.nif}
									margin="normal"
									onChange={this.handleChange}
								/>
							</Grid>
						</Grid>
				</Grid>
				{this.renderPortrait()}
			</Grid>
			<Grid item>
				<TextField
					id="experienceYears"
					name="experienceYears"
					label="Years of experience: "
					defaultValue={(newDate.getFullYear()-this.props.cv.firstYearOfExperience)}
					margin="normal"
					onChange={this.handleChangeFYE}
				/>
			</Grid>
			<Grid item className="sectionTitle" xs={12}>
				Sectors of activity
			</Grid>
			<Grid item>
				<FormControlLabel 
						control={
							<Checkbox
								defaultChecked={(this.props.cv.sectors&1)>0}
								value="sec_1"
								color="primary"
								onChange={this.handleSector}
							/>
						}
						label="Económico/Seguros/Financiero"
					/>
			</Grid>
			<Grid item>
				<FormControlLabel 
						control={
							<Checkbox
								defaultChecked={(this.props.cv.sectors&2)>0}
								value="sec_2"
								color="primary"
								onChange={this.handleSector}
							/>
						}
						label="Médico/Farmacéutico"
					/>
			</Grid>
			<Grid item>
				<FormControlLabel 
						control={
							<Checkbox
								defaultChecked={(this.props.cv.sectors&4)>0}
								value="sec_4"
								color="primary"
								onChange={this.handleSector}
							/>
						}
						label="Técnico/Industrial"
					/>
			</Grid>
			<Grid item>
				<FormControlLabel 
						control={
							<Checkbox
								defaultChecked={(this.props.cv.sectors&8)>0}
								value="sec_8"
								color="primary"
								onChange={this.handleSector}
							/>
						}
						label="Localización de sitios web"
					/>
			</Grid>
			<Grid item>
				<FormControlLabel 
						control={
							<Checkbox
								defaultChecked={(this.props.cv.sectors&16)>0}
								value="sec_16"
								color="primary"
								onChange={this.handleSector}
							/>
						}
						label="Marketing / Publicidad / Audiovisual"
					/>
			</Grid>
			<Grid item>
				<FormControlLabel 
						control={
							<Checkbox
								defaultChecked={(this.props.cv.sectors&32)>0}
								value="sec_32"
								color="primary"
								onChange={this.handleSector}
							/>
						}
						label="Institucional"
					/>
			</Grid>
			<Grid item>
				<FormControlLabel 
						control={
							<Checkbox
								defaultChecked={(this.props.cv.sectors&64)>0}
								value="sec_64"
								color="primary"
								onChange={this.handleSector}
							/>
						}
						label="Jurídico"
					/>
			</Grid>
			<Grid item className="sectionTitle" xs={12}>
				Languages
			</Grid>
			<Grid container item direction="row" alignItems="stretch" justify="flex-start" xs={12}>
				{languagePairs}
			</Grid>
			<Grid item className="sectionTitle" xs={12}>
				EDUCACIÓN Y FORMACIÓN
			</Grid>
			<Grid item>
				{education}
			</Grid>
			<Grid item className="sectionTitle" xs={12}>
				EXPERIENCIA
			</Grid>
			<Grid item>
				{practices}
			</Grid>
			<Grid item className="sectionTitle" xs={12}>
				COMPETENCIAS DE IDIOMAS
			</Grid>
			<Grid item>
				<textarea
					onChange={this.handleChange}
					style={{width: "100%"}}
					rows="4"
					id="languageComp"
					name="languageComp"
					value={this.props.cv.languageComp}
				/>
			</Grid>
			<Grid item className="sectionTitle" xs={12}>
				COMPETENCIAS DIGITALES
			</Grid>
			<Grid item>
				<textarea
					onChange={this.handleChange}
					style={{width: "100%"}}
					rows="4"
					id="digitalComp"
					name="digitalComp"
					value={this.props.cv.digitalComp}
				/>
			</Grid>
			<Grid item className="sectionTitle" xs={12}>
				VALORACIONES
			</Grid>
			<Grid item>
				<Table className="lst">
					<TableHead>
						<TableRow>
							<TableCell></TableCell>
							<TableCell>22/10/2020</TableCell>
							<TableCell>15/6/2020</TableCell>
							<TableCell>18/12/2019</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						<TableRow>
							<TableCell>Estilistic</TableCell>
							<TableCell>9</TableCell>
							<TableCell>8</TableCell>
							<TableCell>8</TableCell>
						</TableRow>
						<TableRow>
							<TableCell>Gramatic/ortografic</TableCell>
							<TableCell>7</TableCell>
							<TableCell>8</TableCell>
							<TableCell>7</TableCell>
						</TableRow>
						<TableRow>
							<TableCell>Localization</TableCell>
							<TableCell>8</TableCell>
							<TableCell>7</TableCell>
							<TableCell>7</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</Grid>
			<Grid item>
				<Button variant="contained" color="primary" aria-label="Save" onClick={this.handleSubmit.bind(this)}>
					Save
				</Button>
			</Grid>
		</Grid>
		</form>
		</div>
		)
	}
}

export default Curriculum;


				